import type {
  RailwayDeployEnvVar,
  RailwayService,
  RailwaySession
} from '@cli-types/next-adapter/railway.js'
import { ENV_TIMEOUT_MS } from '@cli-constants/timeouts.js'
import { runRailway } from '@next-adapter/init/railway/runner/run-railway.js'

export async function setRailwayVariable(
  session: RailwaySession,
  cwd: string,
  service: RailwayService,
  variable: RailwayDeployEnvVar
): Promise<boolean> {
  const result = await runRailway(
    session.runner,
    [
      'variable',
      'set',
      variable.key,
      '--stdin',
      '--skip-deploys',
      '--service',
      service.name,
      '--environment',
      session.project.environmentName,
      '--json'
    ],
    {
      cwd,
      mode: 'capture',
      timeoutMs: ENV_TIMEOUT_MS,
      env: session.env,
      stdinInput: variable.value
    }
  )
  return result.success
}
